/* unplugin-vue-components disabled */import { render } from "./MobileHeader.vue?vue&type=template&id=5c81d290&scoped=true&ts=true"
import script from "./MobileHeader.vue?vue&type=script&lang=ts"
export * from "./MobileHeader.vue?vue&type=script&lang=ts"

import "./MobileHeader.vue?vue&type=style&index=0&id=5c81d290&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c81d290"]])

export default __exports__